/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { icons } from '../../../../../assets';
import { appHistoryPush } from '../../../../../modules/app/appHistory';
import { ELogBusinessEventName, ELogBusinessEventType } from '../../../../../modules/logging/loggingConstants';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { makeSelectGuardComponents } from '../../../../../modules/role/selectors/guardSelector';
import { getPagePaymentsUrl, isPagePaymentsExternalUrl } from '../../../../../pages/PagePayments/utils/getPaymentsUrl';
import { openExternalRoute } from '../../../../../routes/constants/externalRoutes';
import { IRouteParams } from '../../../../../routes/constants/routesConstants';
import { TTableButtonsGetTranslation, TTableButtonsLogBusinessEvent } from '../useTableFooterButtons';

const useTableFooterButtonPayment = (
    getTranslation: TTableButtonsGetTranslation,
    logBusinessEvent: TTableButtonsLogBusinessEvent,
) => {
    const { clientId } = useParams<IRouteParams>();

    const componentsFeature = useSelector(makeSelectGuardComponents());

    return {
        className: 'table-footer__link link-payment',
        dataName: 'payment',
        icon: icons.paymentIconSmall,
        id: AccessComponentKeyEnum.FooterButtonPayment,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonPayment),

        onClick: useCallback(() => {
            logBusinessEvent(ELogBusinessEventName.USER_SHOW_PAYMENTS, ELogBusinessEventType.common);
            const url = getPagePaymentsUrl(componentsFeature, clientId);
            isPagePaymentsExternalUrl(componentsFeature) ? openExternalRoute(url) : appHistoryPush(url);
        }, [componentsFeature, logBusinessEvent, clientId]),
    };
};

export default useTableFooterButtonPayment;
